import { Group, Rect, Line } from 'react-konva';
import React from 'react';
import { GraphStyle } from '../types';



function GridBG({
	columns = 20,
	rows = 5,
	style,
	...props
}: GridBGProps) {

	// RENDER
	return (
		<Group
			{...props}
			listening={false}
		>
			{Array.from({ length: columns }).map((_, index) => index % 2 == 0 && (
				<Rect key={index}
					x={index * style.space.x}
					y={0}
					width={style.space.x}
					height={style.space.y * rows}
					fill={style.bg.column0.color}
				/>
			))}

			{Array.from({ length: rows + 1 }).map((_, index) => (
				<Line key={index}
					points={[0, (index * style.space.y), columns * style.space.x, (index * style.space.y)]}
					stroke={style.bg.row.color}
					strokeWidth={1}
				/>
			))}
		</Group>
	);
}

export default GridBG

type GridBGProps = {
	columns: number,
	rows: number,
	style: GraphStyle,
}